/* @flow */
/* eslint-disable babel/no-invalid-this */
import type { RuntimeHistoryFeature } from "./types";
import { getLanguageSet } from "nx-components/Locales";

export default function RuntimeHistory(feature: RuntimeHistoryFeature) {
  const language = getLanguageSet().nexia_mobile.device_features
    .runtime_history;
  let getRuntimeHistoryAction = feature.actions.get_runtime_history;
  let getMonthlyRuntimeHistoryAction =
    feature.actions.get_monthly_runtime_history;

  this.getMonthlyRuntimeHistory = () =>
    this.executeDeviceAction(
      getMonthlyRuntimeHistoryAction,
      {},
      {
        updateModelWithResponse: false,
        message: language.retrievingMonthlyHistory,
      }
    );

  this.getDailyRuntimeHistory = () =>
    this.executeDeviceAction(
      getRuntimeHistoryAction,
      {},
      {
        updateModelWithResponse: false,
        message: language.retrievingDailyHistory,
      }
    );
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/runtime_history.js